export default {"src":"/_next/static/media/Versatile.a2959513.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};